var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFragVizDendrogram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 32,
    viewBox: "0 0 160 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#6369D1",
    strokeWidth: 2,
    d: "M0 65L0 0 160 0 160 65"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 6)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "#6369D1",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 26h7.5c3.59 0 6.5-2.91 6.5-6.5s2.91-6.5 6.5-6.5H34",
    transform: "translate(29 13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 39h7.5c3.59 0 6.5-2.91 6.5-6.5s2.91-6.5 6.5-6.5H34",
    transform: "translate(29 13) matrix(1 0 0 -1 0 65)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 13h7.5c3.59 0 6.5-2.91 6.5-6.5S43.91 0 47.5 0H61M62 26h6.294c2.21 0 4-1.79 4-4s1.791-4 4-4H87",
    transform: "translate(29 13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 34h6.294c2.21 0 4-1.79 4-4s1.791-4 4-4H87",
    transform: "translate(29 13) matrix(1 0 0 -1 0 60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 26h7.5c3.59 0 6.5-2.91 6.5-6.5s2.91-6.5 6.5-6.5H61",
    transform: "translate(29 13) matrix(1 0 0 -1 0 39)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 13L61 13M51 26L83 26",
    transform: "translate(29 13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 52h7.5c3.59 0 6.5-2.91 6.5-6.5s2.91-6.5 6.5-6.5H61",
    transform: "translate(29 13) matrix(1 0 0 -1 0 91)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 39L61 39",
    transform: "translate(29 13)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFragVizDendrogram);
export default __webpack_public_path__ + "static/media/frag_viz_dendrogram.a84b9ba31da540d234afef2800fc5b6a.svg";
export { ForwardRef as ReactComponent };